<loading-indicator [state]="state"></loading-indicator>

<div *ngIf="survey && survey.state == 'open'">
  <app-survey-submit [survey]="survey"></app-survey-submit>
</div>

<div *ngIf="survey && survey.state == 'submitted'">
  <app-survey-result [survey]="survey"></app-survey-result>
</div>
